"use client"

import { useActionState } from "react"
import Input from "@modules/common/components/input"
import { LOGIN_VIEW } from "@modules/account/templates/login-template"
import ErrorMessage from "@modules/checkout/components/error-message"
import { SubmitButton } from "@modules/checkout/components/submit-button"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { signup } from "@lib/data/customer"
import T from "@lib/i18n/t"
import { useT } from "@lib/i18n/client"

type Props = {
  setCurrentView: (view: LOGIN_VIEW) => void
}

const Register = ({ setCurrentView }: Props) => {
  const t = useT()
  const [message, formAction] = useActionState(signup, null)

  return (
    <div
      className="max-w-sm flex flex-col items-center"
      data-testid="register-page"
    >
      <h1 className="text-large-semi uppercase mb-6">
        <T>Załóż konto w Ateisci.com</T>
      </h1>
      <p className="text-center text-base-regular text-ui-fg-base mb-4">
        <T>Konto pozwala śledzić zamówienia i zapisać adres wysyłki na przyszłość.</T>
      </p>
      <form className="w-full flex flex-col" action={formAction}>
        <div className="flex flex-col w-full gap-y-2">
          <Input
            label={t("Imię")}
            name="first_name"
            required
            autoComplete="given-name"
            data-testid="first-name-input"
          />
          <Input
            label={t("Nazwisko")}
            name="last_name"
            required
            autoComplete="family-name"
            data-testid="last-name-input"
          />
          <Input
            label={t("E-mail")}
            name="email"
            required
            type="email"
            autoComplete="email"
            data-testid="email-input"
          />
          <Input
            label={t("Telefon")}
            name="phone"
            type="tel"
            autoComplete="tel"
            data-testid="phone-input"
          />
          <Input
            label={t("Hasło")}
            name="password"
            required
            type="password"
            autoComplete="new-password"
            data-testid="password-input"
          />
        </div>
        <ErrorMessage error={message} data-testid="register-error" />
        <span className="text-center text-ui-fg-base text-small-regular mt-6">
          <T>Zakładając konto akceptujesz</T>{" "}
          <LocalizedClientLink
            href="/content/privacy-policy"
            className="underline"
          >
            <T>politykę prywatności</T>
          </LocalizedClientLink>{" "}
          <T>oraz</T>{" "}
          <LocalizedClientLink
            href="/content/terms-of-use"
            className="underline"
          >
            <T>regulamin</T>
          </LocalizedClientLink>
          .
        </span>
        <SubmitButton className="w-full mt-6" data-testid="register-button">
          <T>Załóż konto</T>
        </SubmitButton>
      </form>
      <span className="text-center text-ui-fg-base text-small-regular mt-6">
        <T>Masz już konto?</T>{" "}
        <button
          onClick={() => setCurrentView(LOGIN_VIEW.SIGN_IN)}
          className="underline"
        >
          <T>Zaloguj się</T>
        </button>
        .
      </span>
    </div>
  )
}

export default Register
